<template>
  <div class="bg" v-if="canEdit">
    <div class="top_search_part">
      <div class="add_btn" @click="addInsertImg">{{$t('message.signatureInsertImgText')}}</div>
    </div>
    <div class="content">
      <el-upload :action="uploadUrl" list-type="picture-card" :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
  <div class="bg" v-else>
    <div class="imgBox">
      <el-image v-for="(pic, index) in pic_list" :key="index" :src="pic.imgSrc" class="uploadImgShow" :preview-src-list="srcList"></el-image>
    </div>
  </div>
</template>

<script>
  import { imgSrc, getSignImgs, uploadImg, setSignImgs } from '@/api/getData.js'
  export default {
    name: 'signatureFormImgs',
    data () {
      return {
        canEdit: false,
        pid: '',
        page_no: 1,
        page_size: 10,
        pic_list: [],
        srcList: []
      }
    },
    created() {
      let query = this.$route.query
      if (query.hasImg === 0) {
        // 上传图片
        this.canEdit = true
        this.pid = query.GUID
      } else {
        // 查询签约单图片
        this.canEdit = false
        this.pid = query.GUID
        this.getSignImgs()
      }
    },
    methods: {
      // 查询签约单图片
      async getSignImgs () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = {}
        param.PID = this.pid
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getSignImgs(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        this.totalSize = res.data.num
        let srcList = this.srcList
        this.pic_list = res.data.dt.map(item => {
          item.imgSrc = imgSrc(item.PICNAME)
          srcList.push(imgSrc(item.PICNAME))
          return item
        })
        this.srcList = srcList
      },
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg'
        if (!isJPG) {
          this.$message.error(this.$t('message.uploadImgErrorFormatText'))
        }
        return isJPG
      },
      handleSuccess (file) {
        // console.log('handleSuccess:', file)
        if (file.result !== '1') {
          this.$message.error(this.$t('message.uploadImgErrorTipsText'))
          return
        }
        this.pic_list.push(file.data)
      },
      handleError (err) {
        // console.log('handleError:', err, file)
        this.$message.error(err)
      },
      handleRemove (file) {
        // console.log('handleRemove:', file.name)
        if (file.status === 'success') {
          let pic_list = this.pic_list
          for (let i = 0; i < pic_list.length; i++) {
            if (pic_list[i].fileoldname === file.name) {
              pic_list.splice(i, 1)
              break
            }
          }
          this.pic_list = pic_list
        }
      },
      // 确定上传图片
      async addInsertImg () {
        if (this.pic_list.length === 0) {
          this.$message.error(this.$t('message.uploadImgNoImgTitle'))
        } else {
          this.$confirm(this.$t('message.signatureInsertImgPrompt'), this.$t('message.promptTitle'), {
            confirmButtonText: this.$t('message.confirmText'),
            cancelButtonText: this.$t('message.cancleText')
          }).then(() => {
            this.setSignImgs()
          }).catch(() => {
            this.$message(this.$t('message.canclePrompt'));
          });
        }
      },
      async setSignImgs () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = []
        let pic_list = this.pic_list
        for (let i = 0; i < pic_list.length; i++) {
          let obj = { PID: this.pid, PICNAME: pic_list[i].filename }
          param.push(obj)
        }
        let res = await setSignImgs(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.page_no = 1
          this.canEdit = false
          this.getSignImgs()
        }
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      }
    }
  }
</script>

<style scoped>
.content {
  padding: 20px 20px 28px;
  overflow-y: scroll;
  display: flex;
  justify-content: flex-start;
  align-items: auto;
  flex-wrap: wrap;
}
.content::-webkit-scrollbar { width: 0 !important; }
.content{ /* -ms-overflow-style: none; */ -ms-overflow-x: unset; }
.content { overflow: -moz-scrollbars-none; }
.imgBox {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
  align-items: auto;
  flex-wrap: wrap;
}
.uploadImgShow {
  width: 200px;
  height: 200px;
  margin: 10px;
}
</style>
